import * as t from "io-ts";
import { LocalDateTimeFromIsoStringC } from "../../codecs/localDate";
import * as O from "fp-ts/lib/Option";
import { LocalDateTime } from "@js-joda/core";
import { OptionFromNullableC, optionFromNullable } from "io-ts-types/lib/optionFromNullable";

export type InvestorC = t.TypeC<{
  userId: t.NumberC,
  name: t.StringC
}>;
export type Investor = {
  userId: number,
  name: string
};
export const investorC: InvestorC = t.type({
  userId: t.number,
  name: t.string
}) satisfies t.Type<Investor, unknown>;


export type DetailsC = t.TypeC<{
  activityOrItemId: t.NumberC,
  investor: InvestorC,
  dateTime: LocalDateTimeFromIsoStringC
}>;
export type Details = {
  activityOrItemId: number,
  investor: Investor,
  dateTime: LocalDateTime
};
export const detailsC: DetailsC = t.type({
  activityOrItemId: t.number,
  investor: investorC,
  dateTime: LocalDateTimeFromIsoStringC
}) satisfies t.Type<Details, unknown>;


export type TabCountC<A1 extends t.Mixed> = t.TypeC<{
  t: OptionFromNullableC<A1>,
  count: t.NumberC
}>;
export type TabCount<A1> = {
  t: O.Option<A1>,
  count: number
};
export const tabCountC = <A1 extends t.Mixed>(A1: A1): TabCountC<A1> => t.type({
  t: optionFromNullable(A1),
  count: t.number
}) satisfies t.Type<TabCount<t.TypeOf<A1>>, unknown>;


